import { z } from 'zod';
import type { SubmitNativeApplicationRequestT } from '@lotushealth/lotushealth_js_sdk/schemas';

import { useZodForm } from '@/shared/lib/forms';
import { npiField, phoneField } from '@/shared/lib/validators';

const initialScreeningSchema: z.ZodType<SubmitNativeApplicationRequestT> = z.object({
  display_name: z.string().trim().min(1, 'Full name is required'),
  email: z.string().trim().email('A valid email is required'),
  phone_number: phoneField,
  referral_source: z.string().trim().nullish(),
  referral_person_name: z.string().trim().nullish(),
  resume_file_id: z.string().nullish(),
  medical_school: z.string().trim().min(1, 'Medical school is required'),
  degree: z.string().trim().min(1, 'Degree is required'),
  residency: z.string().trim().min(1, 'Residency is required'),
  fellowships: z.string().trim().nullish(),
  specialty: z.string().trim().min(1, 'Specialty is required'),
  npi_number: npiField,
  licensed_states: z.array(z.string()).min(1, 'At least one state is required'),
  board_certified: z.boolean({ error: 'Board certification status is required' }),
});

const DEFAULT_VALUES: SubmitNativeApplicationRequestT = {
  display_name: '',
  email: '',
  phone_number: '',
  medical_school: '',
  degree: '',
  residency: '',
  specialty: '',
  npi_number: '',
  licensed_states: [],
  board_certified: false,
};

export function useInitialScreeningForm() {
  const { form, validateDraft } = useZodForm<SubmitNativeApplicationRequestT>({
    schema: initialScreeningSchema,
    defaultValues: DEFAULT_VALUES,
  });

  return { form, validateDraft };
}
